import { render, staticRenderFns } from "./CopyToClipBoardLink.vue?vue&type=template&id=66031842&scoped=true"
import script from "./CopyToClipBoardLink.vue?vue&type=script&lang=js"
export * from "./CopyToClipBoardLink.vue?vue&type=script&lang=js"
import style0 from "./CopyToClipBoardLink.vue?vue&type=style&index=0&id=66031842&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66031842",
  null
  
)

export default component.exports